import request from "project-config/services/request/request";

export async function downloadRequest(api: string, params?: Record<any, any>) {
  return request.post(api, params, {
    config: {
      responseType: "blob",
    },
    returnDataOnly: false,
  }) as unknown as RequestResponse;
}
